/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YearSpendingDto
 */
export interface YearSpendingDto {
    /**
     * 
     * @type {number}
     * @memberof YearSpendingDto
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof YearSpendingDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof YearSpendingDto
     */
    orderCount?: number;
}

/**
 * Check if a given object implements the YearSpendingDto interface.
 */
export function instanceOfYearSpendingDto(value: object): value is YearSpendingDto {
    return true;
}

export function YearSpendingDtoFromJSON(json: any): YearSpendingDto {
    return YearSpendingDtoFromJSONTyped(json, false);
}

export function YearSpendingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearSpendingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'] == null ? undefined : json['year'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
    };
}

export function YearSpendingDtoToJSON(json: any): YearSpendingDto {
    return YearSpendingDtoToJSONTyped(json, false);
}

export function YearSpendingDtoToJSONTyped(value?: YearSpendingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'amount': value['amount'],
        'orderCount': value['orderCount'],
    };
}

